import React from 'react';
import { createStore, useStore } from 'zustand';

const initialState = {
  counter: 0,
  modalCounter: 0,
  errors: {},
  modalErrors: {}
};

let zustandStore = (set, get) => ({
  ...initialState,
  addError: (errorObject, status = 'warning') =>
    set(state => {
      const pageErrorStatuses = get().errors || {};
      const pageErrorsStatusMessages = pageErrorStatuses[status] || [];

      const isAlreadyAdded = pageErrorsStatusMessages.find(eK => eK?.key === errorObject?.key);

      return {
        counter: state.counter + 1,
        errors: {
          ...state.errors,
          [status]: isAlreadyAdded
            ? pageErrorsStatusMessages
            : [...pageErrorsStatusMessages, errorObject]
        }
      };
    }),

  addModalError: (errorKeys, status = 'warning') =>
    set(state => {
      return {
        modalCounter: state.modalCounter + 1,
        modalErrors: {
          [status]: Array.isArray(errorKeys) ? errorKeys : [errorKeys]
        }
      };
    }),

  addErrors: (errorKeys, status = 'warning') =>
    set(state => {
      return {
        errors: {
          [status]: Array.isArray(errorKeys) ? errorKeys : [errorKeys]
        },
        counter: state.counter + 1
      };
    }),

  removeError: (errorObject, status = 'warning') =>
    set(state => {
      const pageErrorStatuses = get().errors || {};
      const pageErrorsStatusMessages = pageErrorStatuses[status] || [];

      return {
        errors: {
          ...state.errors,
          [status]: pageErrorsStatusMessages.filter(eK => eK?.key !== errorObject?.key)
        }
      };
    }),

  resetPageErrors: () =>
    set(state => {
      return {
        errors: {
          ...state.errors,
          [window.location.pathname]: {}
        }
      };
    }),

  checkError: (errorKey, status = 'warning') => {
    const errors = get().errors[status] || [];
    return errors.some(error => error.key === errorKey);
  },

  reset: () => set(initialState)
});

export const ValidationErrorsContext = React.createContext();

export default function ValidationErrorsProvider({ children }) {
  const [store] = React.useState(() => createStore(zustandStore));

  return (
    <ValidationErrorsContext.Provider value={store}>{children}</ValidationErrorsContext.Provider>
  );
}

const useValidationErrorsStore = selector => {
  const store = React.useContext(ValidationErrorsContext);
  if (!store) {
    return initialState;
  }
  return useStore(store, selector);
};

export { useValidationErrorsStore };
